import { uniq } from "lodash-es";

import TableCellLabels from "ds/components/Table/Row/CellLabels";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { SCAN_PROVIDER_LABEL } from "../constants";
import { ScansListItem } from "../../../types";

const ScansTableProviderCell = ({
  item: scan,
  ...cellProps
}: TableSimpleCellProps<ScansListItem>) => {
  const providers = uniq(scan.providerConfigs.map(({ type }) => SCAN_PROVIDER_LABEL[type]));

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels tags={providers} />
    </TableSimpleCell>
  );
};

export default ScansTableProviderCell;
